<!--
    Component Link
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">
		<div class="content">
			<div class="bar darkText largeText">
				<div class="gridLabel gridRight bg-links">{{ model.getDictionary('nav_link')}}</div>
			</div>

			<div class="link-grid">
				<link-tile v-for="link in links" :key="link.seq" :link="link"></link-tile>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import { model } from "./../model/Model.js";

	const LinkTile = Vue.component("link-tile", {
		props: ["link"],
		template: `<a class='link-tile' :href="link.link" target='_BLANK' >{{ link.label }}</a>`
	});

	export default {
		components: { LinkTile },

		data: function() {
			return {
				// access the model for translations
				model: model,

				// list of links
				links: model.blockLink
			};
		}
	};
</script>

<style>

@media (min-width: 1000px) {

	div.gridRight {
		margin-left: 45rem;
	}

	a.link-tile {
		display: block;
		text-align: right;
		padding-right: 2rem;
		margin-bottom: 2rem;
	}

}

@media (max-width: 1000px) {
	
	a.link-tile {
		display: block;
		text-align: right;
		padding-right: 2rem;
		margin-bottom: 2rem;
	}
	
}

</style>